import { MainLayout } from "~/components";
import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { HeroPage } from "./HeroPage";
import { height } from "@mui/system";
import { skillsgraph } from "~/assets";
import { skillsgraph2 } from "~/assets";
import Typography from "@mui/material/Typography";
import Box from "@material-ui/core/Box";
import { skillsMobile } from "~/assets";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${skillsMobile})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "auto",
    backgroundSize:'100%',

    [theme.breakpoints.up('sm')]:{
      backgroundImage: 'none'
    },
  },
  desktop:{
    display:'none',
    [theme.breakpoints.up('sm')]:{
      display: 'flex'
    },
  },

  mobile: {
    display:'flex',
    [theme.breakpoints.up('sm')]:{
      display: 'none'
    },
  }
}));

export const Skillsection = () => {

  const classes= useStyles()

  return (
    <Box className={classes.root} maxWidth="1440px" width="100%">
      <Box marginX={{ xs: 2, lg: 10, xl:0 }} mt={{lg:10, xs: 2}}>
        <Box paddingTop={{xs:15, lg: 0}} textAlign={"center"}>
          <Typography fontSize={{xs:'24px', lg:'40px'}} variant="h6">$SKILLS Token Utility</Typography>
        </Box>

        <Box className={classes.desktop} display="flex" justifyContent="center" alignItems="center">
          <img src={skillsgraph2} alt="graph" height="100%" width="100%" />
        </Box>

        <Box 
        className={classes.mobile} 
        flexDirection='column'
        mt={10}
        mb={10}
        paddingTop={25}
        >
          
          <Typography textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
          The only payment method
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Ecosystem activities
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Selecting projects and learning paths
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Downloading learning resources
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Submitting project requests
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Sending personal Q&A to project creators in DLA
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Staking
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Exclusive access to mentors
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Transfer taxes
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Farming
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Rewards system
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Educational levels NFTs
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Loyalty and affiliate programmes
          </Typography>
          <Typography mt={2} textAlign='center' fontSize='15px' lineHeight='26px' variant='body2'>
            Community-drven skill development
          </Typography>
        </Box>

      </Box>
    </Box>
  );
};
